package com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberCoroutineScope
import com.cybersoftsolution.cybersoftsolutionweb.components.navigation.AdminNavigationItems
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.sidePanelCollapsedHeight
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.sidePanelInternalWidth
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateX
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.icons.fa.FaBars
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.plus
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

@Composable
fun SidePanelInternal(isOpen: Boolean) {
    val scope = rememberCoroutineScope()
    val context = rememberPageContext()
    val breakpoint = rememberBreakpoint()

    var translateX by remember {
        mutableStateOf((0).percent)

    }
    var opacity by remember {
        mutableStateOf((100).percent)

    }

    LaunchedEffect(isOpen) {
        if (isOpen) {
            translateX = 0.percent
            opacity = 100.percent
        } else {
            scope.launch {
                opacity = 0.percent
                delay(500)
                translateX = (-100).percent
            }



        }

    }

                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .opacity(opacity)
                            .transition(
                                Transition.of(
                                    property = "opacity",
                                    duration = 500.ms,
                                    timingFunction = null,
                                    delay = null
                                )
                            )


                    ) {
                        Column(
                            modifier = Modifier

                                .translateX(translateX)
                                .backgroundColor(Theme.Primary.rgb)
//                .backgroundColor(Colors.DarkGray)
//                .width(250.px)
//                .backgroundImage(linearGradient(
//                    angle = 90.deg,
//                    Theme.PrimaryButton.rgb,
////                    Colors.DarkGreen,
//                    Theme.DarkGray.rgb
//
//                ))

//                .border(1.px, LineStyle.Solid, Colors.DarkGreen)
                                .border(
                                    width = 3.px,
                                    style = LineStyle.Solid,
                                    color = Theme.Withe.rgb
                                )
                                .borderRadius(
                                    25.px,
//                bottomRight = 25.px,
//                topLeft = 25.px,

                                )

//                .boxShadow(blurRadius = 5.px, spreadRadius = 3.px, color = Colors.ForestGreen)
                                .width(sidePanelInternalWidth)
                                .margin(
                                    top = (sidePanelCollapsedHeight + 36.px ),
                                )
//                .height(100.vh)
//                                .height(screenHeightFull.px)
                                .height(90.vh)
//                              .height(90.percent)
//                                .position(Position.Fixed)
                                .padding(leftRight = 20.px, topBottom = 50.px)
                                .zIndex(9) //posicionamiento de panel lateral sobre el contenido principal


                        ){
//            Image(
//                modifier = Modifier
//                    .width(100.percent)
//                    .margin(bottom = 50.px),
//                src = Resources.Images.banner,
//                alt = "Banner Image",
//            )

                            Row (
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .margin(bottom = 30.px)
                                ,
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.Center
                            ){
                                FaBars(
                                    modifier = Modifier
                                        .color(unselectedColor),
                                    size = IconSize.XL,
                                )

                                SpanText(
                                    modifier = Modifier
//                        .fillMaxWidth()
                                        .margin(left = 10.px)

                                        .color(unselectedColor)
                                        .fontSize(14.px),

                                    text = "Menu de Administración",


                                    )
                            }


                            AdminNavigationItems(context = context)



                        }

                    }



}

